import { useEffectOnce } from 'react-use';
import { logger } from '@zep/core-logger';
import { InquiryBanner } from '../../components/service/stores/StoreBanner/InquiryBanner';
import StorePopularList from '../../components/service/stores/StoreList/StorePopularList';
import StoreRecommendedList from '../../components/service/stores/StoreList/StoreRecommendedList';
export const StorePageView = () => {
  useEffectOnce(() => {
    logger.track('enter_store');
  });
  return <>
      <InquiryBanner style={{
      marginTop: '28px'
    }} data-sentry-element="InquiryBanner" data-sentry-source-file="store.tsx" />
      <StoreRecommendedList type="map" data-sentry-element="StoreRecommendedList" data-sentry-source-file="store.tsx" />
      <StoreRecommendedList type="app" data-sentry-element="StoreRecommendedList" data-sentry-source-file="store.tsx" />
      <StorePopularList type="map" data-sentry-element="StorePopularList" data-sentry-source-file="store.tsx" />
      <StorePopularList type="object" data-sentry-element="StorePopularList" data-sentry-source-file="store.tsx" />
      <StorePopularList type="app" data-sentry-element="StorePopularList" data-sentry-source-file="store.tsx" />
      <StorePopularList type="game" data-sentry-element="StorePopularList" data-sentry-source-file="store.tsx" />
    </>;
};